module.exports = __webpack_public_path__ + "img/Compact-SR_Overview-Front_1.3a7495ea.jpg";